{
  "confirmClosePosition": {
    "title": "Позиция будет закрыта, когда откроется рынок",
    "description_1": "При использовании функции \"Закрытие позиции\" происходит автоматическое выставление Market ордера на продажу (если позиция была открыта в Long) или покупку (если позиция была открыта в Short).",
    "description_2": "Пожалуйста, имейте в виду, что Market ордер будет исполнен сразу же после открытия рынка, но цена может отличаться от текущей стоимости из-за возможной высокой волатильности.",
    "description_3": "Рекомендуем быть внимательными к текущим рыночным условиям и принимать решения с учетом возможных колебаний цены.",
    "cancelButton": "Отмена",
    "confirmButton": "Закрыть позицию"
  }
}
